import React, { useState, useCallback } from 'react';  
//import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';  
  
function ClaimButton({ walletAddress, claimToken }) {  
  const [error, setError] = useState(null);  
  //const { executeRecaptcha } = useGoogleReCaptcha();  
  const [processing, setProcessing] = useState(false);

  const handleClick = useCallback(async () => {  
    try {  
      // console.debug('Registered click');  
      
      setProcessing(true);
      await claimToken(walletAddress);

    } catch (err) {  
      console.error('Error claiming token:', err);  
      setError(err.message);  
    } finally {
      setProcessing(false);
    }
  }, [walletAddress, claimToken]);  
  
  return (  
   
      <div className={`claim-section ${processing ? 'loading' : ''}`}>
        <button className="btn btn-get-token" onClick={handleClick}>  
          <div>
            Get 0.05 ETH
          </div>
        </button>  
        {error && <p className="error-message">{error}</p>}  
      </div>  
    
  );  
}  
  
export default ClaimButton;